import { render, staticRenderFns } from "./select-items.vue?vue&type=template&id=0c87c090"
import script from "./select-items.vue?vue&type=script&lang=js"
export * from "./select-items.vue?vue&type=script&lang=js"
import style0 from "./select-items.vue?vue&type=style&index=0&id=0c87c090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports